// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sbolMain[data-v-d98c54fc]{overflow:scroll;font-size:.875rem;font-weight:400;line-height:1.5;color:#202832;text-align:left;margin:0;padding:10px}.panel[data-v-d98c54fc]{position:absolute;right:1em;font-size:2em}.empty[data-v-d98c54fc]{background-color:#f0f2f5;border-radius:3px;padding:20px;text-align:center;overflow:hidden}.SBOLcontainer[data-v-d98c54fc]{display:grid;grid-template-columns:1fr 2fr;height:680px}nav[data-v-d98c54fc]{padding:0 5px 0 0;min-width:300px}", ""]);
// Exports
module.exports = exports;
